import React from 'react';
import CreateProjectForm from '../components/CreateProjectForm/CreateProjectForm';


function CreateProjectPage() {
    return <CreateProjectForm />;
}

    
export default CreateProjectPage;